/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `GateToDropoffRoute.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { GateToDropoffRoute } from "./GateToDropoffRoute";

import { CalendarEventResource } from "./CalendarEventResource";
import { Dropoff } from "./Dropoff";
import { Gate } from "./Gate";
import { MapObject } from "./MapObject";
import { Project } from "./Project";
import { WaypointDirection } from "./WaypointDirection";

export abstract class GateToDropoffRouteModel {
    id: number;
    archived: boolean;
    createdAt: Dayjs;
    dropoffId: number;
    gateId: number;
    name: string | null;
    projectId: number;
    updatedAt: Dayjs;
    calendarEventResources: CalendarEventResource[] | undefined;
    dropoff: Dropoff | null | undefined;
    gate: Gate | null | undefined;
    mapObject: MapObject | null | undefined;
    project: Project | null | undefined;
    waypointDirection: WaypointDirection | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        archived: boolean,
        createdAt: Dayjs,
        dropoffId: number,
        gateId: number,
        name: string | null,
        projectId: number,
        updatedAt: Dayjs,
        calendarEventResources: CalendarEventResource[] | undefined,
        dropoff: Dropoff | null | undefined,
        gate: Gate | null | undefined,
        mapObject: MapObject | null | undefined,
        project: Project | null | undefined,
        waypointDirection: WaypointDirection | null | undefined
    ) {
        this.id = id;
        this.archived = archived;
        this.createdAt = createdAt;
        this.dropoffId = dropoffId;
        this.gateId = gateId;
        this.name = name;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.calendarEventResources = calendarEventResources;
        this.dropoff = dropoff;
        this.gate = gate;
        this.mapObject = mapObject;
        this.project = project;
        this.waypointDirection = waypointDirection;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): GateToDropoffRoute {
        const newObject = new GateToDropoffRoute(
            json["id"],
            json["archived"],
            dayjs(json["created_at"]).tz(timezone),
            json["dropoff_id"],
            json["gate_id"],
            json["name"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["calendar_event_resources"]?.map((item: any) => CalendarEventResource.fromApiObject(item, timezone)),
            json["dropoff"] == null ? json["dropoff"] : Dropoff.fromApiObject(json["dropoff"], timezone),
            json["gate"] == null ? json["gate"] : Gate.fromApiObject(json["gate"], timezone),
            json["map_object"] == null ? json["map_object"] : MapObject.fromApiObject(json["map_object"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["waypoint_direction"] == null
                ? json["waypoint_direction"]
                : WaypointDirection.fromApiObject(json["waypoint_direction"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            archived: this.archived,
            created_at: this.createdAt,
            dropoff_id: this.dropoffId,
            gate_id: this.gateId,
            name: this.name,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            calendar_event_resources_attributes: this.calendarEventResources
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            dropoff_attributes: this.dropoff?.toApiObject(visited),
            gate_attributes: this.gate?.toApiObject(visited),
            map_object_attributes: this.mapObject?.toApiObject(visited),
            project_attributes: this.project?.toApiObject(visited),
            waypoint_direction_attributes: this.waypointDirection?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): GateToDropoffRoute {
        const clone = Object.create(this) as GateToDropoffRoute;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
